import { ChevronDown, Search, SlidersHorizontal } from 'lucide-react';

export const FILTER_UI_ICONS = {
  search: Search,
  chevronDown: ChevronDown,
  sliders: SlidersHorizontal,
};
